/*
 *
 * Alerts constants
 *
 */

export const SUCCESS_SNACKBAR = "app/Alerts/SUCCESS_SNACKBAR";
export const ERROR_SNACKBAR = "app/Alerts/ERROR_SNACKBAR";
export const WARNING_SNACKBAR = "app/Alerts/WARNING_SNACKBAR";
export const CLEAR_SNACKBAR = "app/Alerts/CLEAR_SNACKBAR";
